import React from "react";
import ReactTooltip from "react-tooltip";

export function ActionsColumnFormatter(cellContent, row, rowIndex, { buttons }) {
    return (
        <div className="d-flex align-items-center justify-content-end">
            <ReactTooltip place="top" type="dark" effect="solid" html={true} />

            {buttons &&
            buttons.map((button) => {
                // Optional: hide the button entirely for rows it does not apply to
                if (button.visible && !button.visible(row)) return null;
                const disabled = button.condition && !button.condition(row);

                if (button.label) {
                    return (
                        <a
                            data-tip={button.name}
                            key={button.name}
                            className={`btn btn-${disabled ? 'secondary' : button.color} btn-sm mx-1 px-3${disabled ? ' disabled opacity-25' : ''}`}
                            onClick={disabled ? undefined : () => button.method(row)}
                            style={disabled ? { pointerEvents: 'none' } : {}}>
                            {button.icon && <i className={`fa fa-${button.icon} me-1`} />}
                            {button.label}
                        </a>
                    );
                }

                let aClassName = disabled
                    ? "btn btn-icon btn-light btn-sm mx-1 disabled opacity-25"
                    : "btn btn-icon btn-light btn-hover-" + button.color + " btn-sm mx-1";

                return (
                    <a
                        data-tip={button.name}
                        key={button.name}
                        className={aClassName}
                        onClick={disabled ? undefined : () => button.method(row)}
                        style={disabled ? { pointerEvents: 'none' } : {}}>
                        <i className={`fa fa-${button.icon} text-${disabled ? 'muted' : button.color} fs-6`} />
                    </a>
                );
            })}
        </div>
    );
}

